var map = {
	"./abstract-lines.svg": "1dba",
	"./appmart.svg": "c339",
	"./bg-cubic.svg": "ebb6",
	"./bg_curve.svg": "075d",
	"./biopay.svg": "bc39",
	"./cards.svg": "2aa6",
	"./check.svg": "51c7",
	"./hamburger.svg": "a52e",
	"./line-cc.svg": "c7b1",
	"./logo_a.svg": "6db5",
	"./logo_black.svg": "5959",
	"./logo_white.svg": "3c6f",
	"./partners/NITDA_Audit_Compliant_Logo_june_2022.svg": "5bad",
	"./partners/dss.svg": "6f48",
	"./partners/nitda.svg": "c9a4",
	"./security.svg": "103a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";